import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider, ErrorBoundary } from '@rollbar/react';
import { GraphProvider } from './providers/GraphProvider';

import rollbarConfig from './rollbar.config';

// App
import App from './App';

// CSS
import './css/index.sass';

render(
  <Provider config={rollbarConfig}>
    <ErrorBoundary>
      <BrowserRouter>
        <GraphProvider>
          <App />
        </GraphProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>,
  document.getElementById('app')
);
